import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import {
  Modal,
  Input,
  Button
} from 'antd';
import { useRecoilState } from 'recoil';
import { showChangeApiUrlAtom } from '../../../atoms/Atoms';
import envConfig from '../../../envConfig';

function ChangeUrlModal() {
  const { t } = useTranslation();
  const [url, setUrl] = useState('');
  const [showChangeApiUrl, setShowChangeApiUrl] = useRecoilState(showChangeApiUrlAtom);

  useEffect(() => {
    if (showChangeApiUrl) {
      setUrl(envConfig.REACT_APP_API_URL);
    }
  }, [showChangeApiUrl]);

  return (
    <Modal
      title={t('change_api_url')}
      centered="true"
      open={showChangeApiUrl}
      onCancel={() => { setShowChangeApiUrl(false); }}
      footer={[
        <Button
          key="close"
          danger
          type="primary"
          onClick={() => setShowChangeApiUrl(false)}
        >
          {t('close')}
        </Button>,
        <Button
          key="defaulturl"
          onClick={() => setUrl(envConfig.REACT_APP_DEFAULT_API_URL)}
        >
          {t('default_url')}
        </Button>,
        <Button
          key="set"
          type="primary"
          disabled={url?.length === 0}
          onClick={() => {
            envConfig.REACT_APP_API_URL = url;
            setShowChangeApiUrl(false);
          }}
        >
          {t('set')}
        </Button>
      ]}
    >
      <Input value={url} onChange={(obj) => setUrl(obj.target.value)} />
    </Modal>
  );
}

export default ChangeUrlModal;
